// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Main: {
    btn1: 'Alle',
    btn2: 'Hauptgerichte',
    btn3: 'Getränke',
    btn4: 'Vorspeisen',
    btn5: 'Desserts',
    btn6: 'Salate',
    btn7: 'Frühstück',
    btn8: 'Nargile',
  },
  Salad: {
    saladIsim1: 'Thunfischsalat',
    saladIcerik1: 'Kirschtomaten, Oliven, rote Zwiebeln, Mais, Kapern, Gurke',
    saladIsim2: 'Teriyaki-Hühnersalat',
    saladIcerik2: 'Mais, Kirschtomaten',
    saladIsim3: 'Garnelen-Avocado-Salat',
    saladIcerik3: 'Avocado, Mais, Kirschtomaten',
    saladIsim4: 'Tomaten-Käse-Salat',
    saladIcerik4: 'Tomaten, Gurke, Feta-Käse, Zwiebeln, Mais, Oliven',
  },
  Breakfast: {
    breakfastIsim1: 'Menemen',
    breakfastIcerik1: '',
    breakfastIsim2: 'Vollständiges Frühstück',
    breakfastIcerik2:
      'Wurst, Gebäck, Pommes, Honig, Marmelade, Butter, Weißkäse, Cheddar, Oliven, Gurke, Tomaten, gekochtes Ei',
    breakfastIsim3: 'Spiegelei',
    breakfastIcerik3: 'Roastbeef, Ei',
    breakfastIsim4: 'Ei mit Pastrami',
    breakfastIcerik4: 'Pastrami, Ei',
  },
  Desserts: {
    tatliIsim1: 'Käsekuchen',
    tatliIcerik1: 'Schokolade, Himbeere',
    tatliIsim2: 'Soufflé',
    tatliIcerik2: '- Serviert mit Eis',
    tatliIsim3: 'Panna Cotta',
    tatliIcerik3: 'Himbeere',
    tatliIsim4: 'Cornetto',
    tatliIcerik4: 'Eis',
    tatliIsim5: 'Magnum',
    tatliIcerik5: 'Eis',
  },
  Drinks: {
    icecek1: 'Cola Zero',
    icecek2: 'Cola',
    icecek3: 'Fanta',
    icecek4: 'Sprite',
    icecek5: 'Soda',
    icecek6: 'Fusetea',
    icecek7: 'Capy',
    icecek8: 'Cola 1LT',
    icecek9: 'Sprite 1LT',
    icecek10: 'Fanta 1LT',
    icecek11: 'Soda',
    icecek12: 'Fruchtsoda',
    icecek13: 'Redbull',
    icecek14: 'Tee',
    icecek15: 'Oralet',
    icecek16: 'Nescafe',
    icecek17: 'Türkischer Kaffee',
    icecek18: 'Wasser',
    icecek19: 'Ayran',
    icecek20: 'Tasse Tee',
    icecek21: 'Flasche Cola',
    icecek22: 'Schweppes',
    icecek23: 'Nescafe-Varianten',
    icecek24: 'Rübensaft',
  },
  Antre: {
    antreIsim1: 'Kartoffelauflauf',
    AntreIcerik1: '-',
    antreIsim2: 'Pilze mit Käse überbacken',
    AntreIcerik2: '-',
    antreIsim3: 'Doppelter Kartoffelauflauf',
    AntreIcerik3: '-',
    antreIsim4: 'Garnelenauflauf',
    AntreIcerik4: '-',
    antreIsim5: 'Zwiebelringe',
    AntreIcerik5: '-',
    antreIsim6: 'Gebratene Calamari',
    AntreIcerik6: '-',
    antreIsim7: 'Cigar Börek',
    AntreIcerik7: '- 8 Stück',
    antreIsim8: 'Vorspeisenplatte',
    AntreIcerik8:
      'Pommes, Wurst, Zwiebelringe, Cigar Börek, Nugget, panierte Calamari',
    antreIsim9: 'Hähnchenflügel',
    AntreIcerik9: '- Serviert mit scharfer Sauce, Pommes',
  },
  Course: {
    mnBaslik1: 'Pizza-Varianten',
    anaYemekIsim1: 'Margherita-Pizza',
    anaYemekIcerik1: 'Mozzarella, Tomatenscheiben',
    anaYemekIsim2: 'Gemischte Pizza',
    anaYemekIcerik2:
      'Salami, Wurst, Sucuk, Champignons, grüne Oliven, Paprika, Mais, schwarze Oliven',
    anaYemekIsim3: 'Thunfischpizza',
    anaYemekIcerik3:
      'Thunfisch, Zwiebeln, Paprika, grüne Oliven, Mais, schwarze Oliven',
    anaYemekIsim4: 'Hähnchen-BBQ-Pizza',
    anaYemekIcerik4: 'Mais, Paprika, Zwiebeln, rote Paprika',
    anaYemekIsim5: 'Bolognese-Pizza',
    anaYemekIcerik5: 'Rinderhackfleisch, Mozzarella',
    mnBaslik2: 'Getoastete Sandwich-Varianten',
    anaYemekIsim6: 'Gemischtes Toast',
    anaYemekIcerik6: '- Serviert mit Tomaten und Gurken',
    anaYemekIsim7: 'Käsetoast',
    anaYemekIcerik7: '- Serviert mit Tomaten und Gurken',
    anaYemekIsim8: 'Doppelter Käsetoast',
    anaYemekIcerik8: '- Serviert mit Tomaten und Gurken',
    mnBaslik3: 'Taco-Varianten',
    anaYemekIsim9: 'Hackfleisch-Taco',
    anaYemekIcerik9:
      'Rinderhackfleisch, Zwiebeln, Karotten, Gemüse, Champignons - serviert mit Pommes, Chili-Sauce',
    anaYemekIsim10: 'Hähnchen-Taco',
    anaYemekIcerik10:
      'Hähnchen, Zwiebeln, Karotten, Gemüse, Champignons - serviert mit Pommes, Chili-Sauce',
    anaYemekIsim11: 'Garnelen-Taco',
    anaYemekIcerik11:
      'Garnelen, Zwiebeln, Karotten, Gemüse, Champignons - serviert mit Pommes, Chili-Sauce',
    mnBaslik4: 'Gegrillte Fleischvarianten',
    anaYemekIsim12: 'Hähnchenspieße',
    anaYemekIcerik12: '- Serviert mit Reis, Pommes',
    anaYemekIsim13: 'Ribeye-Steak',
    anaYemekIcerik13: '- Serviert mit Pommes',
    anaYemekIsim14: 'Frikadellen',
    anaYemekIcerik14: '- Serviert mit Reis, Pommes',
    anaYemekIsim15: 'Burger',
    anaYemekIcerik15: '-',
    // ON ALTI YOK
    mnBaslik5: 'Burger-Varianten',
    anaYemekIsim17: 'Hamburger',
    anaYemekIcerik17: '- 120 Gramm',
    anaYemekIsim18: 'Cheeseburger',
    anaYemekIcerik18: '- 120 Gramm',
    anaYemekIsim19: 'Hähnchenburger',
    anaYemekIcerik19: '- 120 Gramm',
    anaYemekIsim20: 'Hamburger-Menü',
    anaYemekIcerik20: '120 Gramm - Serviert mit Pommes und Cola',
    anaYemekIsim21: 'Cheeseburger-Menü',
    anaYemekIcerik21: '120 Gramm - Serviert mit Pommes und Cola',
    anaYemekIsim22: 'Hähnchenburger-Menü',
    anaYemekIcerik22: '120 Gramm - Serviert mit Pommes und Cola',
    mnBaslik6: 'Hähnchengerichte',
    anaYemekIsim23: 'Hähnchen mit Pilzsoße',
    anaYemekIcerik23: '- Serviert mit Kartoffelpüree',
    anaYemekIsim24: 'Hähnchen mit Currysoße',
    anaYemekIcerik24: '- Serviert mit Reis und Gemüse',
    anaYemekIsim25: 'Schnitzelplatte',
    anaYemekIcerik25: '- Serviert mit Pommes',
    mnBaslik7: 'Pasta-Varianten',
    anaYemekIsim26: 'Spaghetti Bolognese',
    anaYemekIcerik26: '-',
    anaYemekIsim27: 'Penne Arrabiata',
    anaYemekIcerik27: 'Knoblauch, Oliven, Tomatensauce',
    anaYemekIsim28: 'Cremige Hähnchenpenne mit Curry',
    anaYemekIcerik28: 'Champignons, Sahne',
    anaYemekIsim29: 'Cremige Penne mit Pesto-Soße',
    anaYemekIcerik29: 'Hähnchen, Basilikum',
    anaYemekIsim30: 'Cremige Linguine mit Garnelen',
    anaYemekIcerik30: '-',
    anaYemekIsim31: 'Manti (Türkische Teigtaschen)',
    anaYemekIcerik31: '-',
    anaYemekIsim32: 'Manti mit Walnusssauce',
    anaYemekIcerik32: '-',
    anaYemekIsim33: 'Cremige Hähnchen-Pilz-Fettuccine',
    anaYemekIcerik33: '-',
    mnBaslik8: 'Wraps-Varianten',
    anaYemekIsim34: 'Hähnchen-Wrap',
    anaYemekIcerik34:
      'Hähnchen, Paprika, Zwiebeln, Champignons, Käse, Chili-Sauce',
    anaYemekIsim35: 'Rindfleisch-Wrap',
    anaYemekIcerik35:
      'Rindfleisch, Paprika, Zwiebeln, Champignons, Käse, Chili-Sauce',
    mnBaslik9: 'Fischarten',
    anaYemekIsim36: 'Roter Meerbarbe',
    anaYemekIcerik36: 'Es wiegt 500 Gramm',
    anaYemekIsim37: 'Gilt-Brasse',
    anaYemekIcerik37: 'Es wiegt zwischen 300-400 Gramm',
  },
  Other: {
    otherIsim1: "Mixed Hookah",
    otherIcerik1: "",
    otherIsim2: "Banana Strawberry Hookah",
    otherIcerik2: "",
    otherIsim3: "Lady Killer",
    otherIcerik3: "",
    otherIsim4: "Lav 66",
    otherIcerik4: "",
    otherIsim5: "Apple hookah",
    otherIcerik5: "",
  },
}
